import { useSelector } from 'react-redux';

import { AuthStatus } from '../enums/AuthStatus';
import { RootState } from '../state/state';

export const useAppAuth = () => {
  const status = useSelector((state: RootState) => state.auth.status);

  const isReduxAuthenticated = status === AuthStatus.Authenticated;

  return {
    status,
    isAuthenticated: isReduxAuthenticated,
    isLoading: status === AuthStatus.FirstLoad || status === AuthStatus.Busy
  };
};
